import 'react';
import { useTheme, jsx } from '@emotion/react';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import CheckmarkIcon from '../../icons/icons/checkmarkIcon.js';
import ErrorIcon from '../../icons/icons/errorIcon.js';
import InfoIcon from '../../icons/icons/infoIcon.js';
import Style from './style.js';

var bannerIconMapping = {
  success: CheckmarkIcon,
  error: ErrorIcon,
  danger: ErrorIcon,
  default: InfoIcon
};
/**
 * The `<Banner />` component provides only the styling and onClick behavior of banners.
 *
 * Management of what banners are showing on the screen must be handled from outside of this component.
 *
 * Banners are not dismissable.
 */

var Banner = _ref => {
  var {
    content,
    onClick,
    type = 'default'
  } = _ref;
  var theme = useTheme();
  var Icon = bannerIconMapping[type];
  return jsx(Style.BannerContainer, {
    bannerType: type,
    onClick: onClick,
    tabIndex: onClick ? 0 : -1
  }, jsx(Style.MainContainer, null, jsx(Style.IconContainer, null, jsx(Icon, {
    fill: theme.COLORS.white
  })), jsx(Style.ContentContainer, null, content)));
};

export { Banner };
